// LEVELS_DATA_FINAL  -  re-exports from modular level files
// Each level group lives in src/data/levels/
import LEVELS_DATA from '../data/levels/index';

export const LEVELS_DATA_FINAL = LEVELS_DATA;
export default LEVELS_DATA_FINAL;
